import { render } from "./downloadTrainingData.view.vue?vue&type=template&id=b37dba58&scoped=true&ts=true"
import script from "./downloadTrainingData.view.vue?vue&type=script&lang=ts"
export * from "./downloadTrainingData.view.vue?vue&type=script&lang=ts"

import "./downloadTrainingData.view.vue?vue&type=style&index=0&id=b37dba58&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37dba58"]])

export default __exports__